import { useTranslation } from 'react-i18next'
import FlowbiteFileCopyAltSolid from '~icons/flowbite/file-copy-alt-solid'
import FluentCheckmark16Filled from '~icons/fluent/checkmark-16-filled'
import { useCopy } from 'src/hooks/useCopy'
import { getStyleMixSeed } from './MultiColumnGenerationForm/controls/booster/StyleMixBooster.helper'

export function StyleSeedContentDisplay(props: { seed?: number }) {
  const [copy, copied] = useCopy()
  const paddedSeed = getStyleMixSeed({ padStart: true, seed: props.seed })
  const displaySeed = getStyleMixSeed({ withPrefix: true, seed: props.seed })
  return (
    <p className="flex gap-1 items-center bg-neutral-100 dark:bg-neutral-800 rounded-md px-3 py-[3px] w-fit text-sm">
      {displaySeed}
      <button
        onClick={() => {
          copy(paddedSeed)
        }}
      >
        {copied ? (
          <FluentCheckmark16Filled className="text-green-500" />
        ) : (
          <FlowbiteFileCopyAltSolid className="text-neutral-600 dark:text-neutral-400" />
        )}
      </button>
    </p>
  )
}

export function StyleSeedLabel() {
  const { t } = useTranslation(['generation'])

  return (
    <p className="flex items-center gap-1">
      {t('generation:style-mix.style-seed')}
      <span className="font-medium bg-[#E5D3F5] text-black text-xs scale-90 origin-left rounded-full px-2 py-px">
        PixAI
      </span>
    </p>
  )
}
